<template>
  <v-app id="forgot-password-app" class="forgotPassword">
    <div class="passwordContainer">
      <img
        class="logo"
        :src="darkMode?brandingService.getLoginDarkLogoUrl():brandingService.getLoginLogoUrl()"
        alt="brandingService.getLoginLogoAlt()"
      />
      <section class="middle form" v-if="!submitted">
        <h1>Forgot Password</h1>
        <p class="instructions">Enter your username to reset your password. You may need to check your spam folder for emails from noreply@wxpcollaboration.hp.com.</p>
        <v-form v-model="allFieldsValid" @submit.prevent>
          <v-text-field
            v-model="userEmail"
            class="email"
            :rules="[rules.required, rules.formatEmail]"
            solo
            flat
            outlined
            dense
            label="Username"
          ></v-text-field>
          <button
            onsubmit="false"
            class="btn btn-primary submit"
            :disabled="!allFieldsValid"
            @click="submitEmail"
          >Submit</button>
        </v-form>
      </section>
      <section class="middle submitted" v-if="submitted">
        <h1>Check Your Email</h1>
        <p>WXP Collaboration will send you an email with a link to reset your password.</p>
      </section>
      <p class="copywrite">© {{currentYear}} HP Inc. <a href="https://www.hp.com/us-en/privacy/privacy-central.html" target="_blank">Privacy Statement</a>,
        <a href="https://support.hp.com/us-en/document/ish_12775809-12775790-16" target="_blank">EULA</a>,
        and <a href="https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf" target="_blank">DPA</a>
      </p>
    </div>
  </v-app>
</template>

<script>
  import BrandingService from '../../../../services/branding.service';
  import ConfigService from '../../../../services/config.service';
  import 'whatwg-fetch';
  import moment from "moment-timezone";

  export default {
    name: 'forgot-password',
    components: {},
    data: function() {
      const isDarkMode = document.documentElement.classList.contains('dark');
      return {
        allFieldsValid: false,
        brandingService: BrandingService,
        darkMode: isDarkMode,
        userEmail: '',
        submitted: false,
        rules: {
          required: value => !!value || 'Required.',
          formatEmail: value => !value || this.validateEmailFormat(value)
        },
        currentYear: moment().year(),
      };
    },
    created: function() {
    },
    methods: {
      emailUpdated: function(newValue) {
        //validation
      },
      submitEmail: function() {
        let self = this;
        ConfigService.getInstance().getAdminService().then(function (serviceUrl) {
          window.fetch(serviceUrl + '/userreg/api/v1/user_password', {
            method: 'POST',
            body: JSON.stringify({
              email: self.userEmail
            }),
            headers: {
              "Content-type": "application/json; charset=UTF-8"
            }
          }).then(()  => {
            self.submitted = true;
          });
        });
      },
      validateEmailFormat(value) {
        let regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(value) || 'Must be a valid username'
      },
    },
    props: {
    }
  }
</script>

<style lang="scss">
  .forgotPassword {
    .passwordContainer {
      width: 50%;
      margin: auto;
      margin-top: 50px;
      text-align: center;
      background-color: var(--panel-background);
      .logo {
        height: 190px;
        margin: auto;
        padding-top: 50px;
        padding-bottom: 50px;
      }
      .middle {
        height: 450px;
        max-width: 465px;
        margin: auto;
        h1 {
          color: var(--text-color);
          text-align: center;
          font-size: 32px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
        .instructions {
          color: var(--text-color);
          text-align: center;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          margin-bottom: 40px;
        }
        .email {
          margin-bottom: 29px;
          .v-label {
            font-size: 16px;
            font-weight: 500;
            color: #6D787E;
          }
          fieldset {
            height: 50px;
            border-radius: var(--text-input-border-radius);
            border-color: var(--stroke-decorative-default);
          }
          legend {
            display: none;
            border-radius: var(--border-radius);
            font-size: 16px;
          }
        }
        .submit {
          width: 100%;
          height: 50px;
        }
      }
    }
  }
</style>
